import React from "react";
import { Card } from "@/components/ui/card";
import { ACTIVITIES } from "@/lib/content";

export default function ActivitiesPage() {
  return (
    <div data-testid="activities-page">
      <section className="bg-primary text-white py-20 md:py-24 relative overflow-hidden">
        <div className="absolute inset-0 opacity-15">
          <img src="https://images.pexels.com/photos/29039800/pexels-photo-29039800.jpeg?auto=compress&cs=tinysrgb&w=2000" alt="" className="w-full h-full object-cover" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs uppercase tracking-widest text-accent font-semibold">Activities</span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mt-3 mb-4" style={{ fontFamily: "Outfit" }}>
            What we do on the ground
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto">
            From training workshops to feed production — a closer look at our ongoing work for the farming community.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {ACTIVITIES.map((a, i) => (
            <Card
              key={a.title}
              className={`overflow-hidden rounded-3xl border-border grid lg:grid-cols-2 gap-0 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
              data-testid={`activity-detail-${i}`}
            >
              <div className="aspect-[4/3] lg:aspect-auto">
                <img src={a.image} alt={a.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <span className="text-xs uppercase tracking-widest text-primary font-semibold mb-2">Activity 0{i + 1}</span>
                <h2 className="text-2xl md:text-3xl font-bold mb-3" style={{ fontFamily: "Outfit" }}>{a.title}</h2>
                <p className="text-muted-foreground leading-relaxed">{a.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
